
const sanitizeTargetName = (name: string) => {
    name = name.replace(/\s+/, ' ');
    name = name.trim();
    return name;
}


export {sanitizeTargetName};
